<template>
  <nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
    <div class="navbar-brand">
      <a class="navbar-item is-hidden-desktop" @click.prevent="menuToggleMobile">
        <b-icon :icon="menuToggleMobileIcon" />
      </a>
      <div class="navbar-item has-control no-left-space-touch">
        <div class="control control-logo">
          <img src="../assets/normal-logo.png" alt="logo">
        </div>
      </div>
    </div>
    <div class="navbar-brand is-right">
      <a
        class="navbar-item navbar-item-menu-toggle is-hidden-desktop"
        @click.prevent="menuNavBarToggle"
      >
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default" />
      </a>
    </div>
    <div class="navbar-menu fadeIn animated faster" :class="{ 'is-active': isMenuNavBarActive }">
      <div class="navbar-end">
        <nav-bar-menu class="has-divider has-user-avatar">
          <b-button
            type="is-text"
            @click="openEditModal()"
          >
            <user-avatar />
          </b-button>
        </nav-bar-menu>
        <router-link to="/owner/functions" v-if="$route.path !== '/owner/functions'">
          <b-button
            type="is-text"
            icon-left="settings-outline"
          ></b-button>
        </router-link>
        <router-link to="/" v-else>
          <b-button
            type="is-text"
            icon-left="home-outline"
          ></b-button>
        </router-link>
        <b-modal :active.sync="isEditModalActive" has-modal-card>
          <password-edit-modal
            @edit-password="onEditPassword" @closemodal="closeEditModal"
          ></password-edit-modal>
        </b-modal>
        <a class="navbar-item is-desktop-icon-only" title="Log out">
          <router-link to="/logout"><b-icon icon="logout" custom-size="default" /></router-link>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import NavBarMenu from '@/components/NavBarMenu.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import PasswordEditModal from '@/components/modal/PasswordReset.vue';

export default {
  name: 'NavBar',
  components: {
    UserAvatar,
    NavBarMenu,
    PasswordEditModal
  },
  data() {
    return {
      isMenuNavBarActive: false,
      isEditModalActive: false,
      onEditPassword: ''
    };
  },
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical';
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger';
    },
    ...mapState(['isNavBarVisible', 'isAsideMobileExpanded', 'userName'])
  },
  methods: {
    openEditModal() {
      this.isEditModalActive = true;
    },
    closeEditModal() {
      this.isEditModalActive = false;
    },
    menuToggleMobile() {
      this.$store.commit('asideMobileStateToggle');
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive;
    }
  }
};
</script>

<style scoped>
.control-logo {
  padding: 20px 20px 20px 100px;
}
.navbar-end {
  display: flex;
  align-items: center;
}
.navbar-end p {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
  color: #5051DB;
}
.navbar-end p, .navbar-end .bell {
  margin-right: 30px;
}
@media screen and (max-width: 768px){
  .navbar-end {
    display: block;
    float: right;
  }
  .navbar-end p {
    margin-bottom: 20px;
  }
  .bell, .settings {
    margin-bottom: 20px;
  }
}
</style>
